import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { KVNavigationMode } from 'types'

import { KVMessageDef } from './index'

export function getNavigationModeUpdatedMessage() {
  return {
    type: 'NavigationModeUpdated',
    requiredData: ['navigationMode'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const navigationMode = json.navigationMode as KVNavigationMode
      if (kv.setNavigationMode) {
        kv.setNavigationMode(navigationMode)
      }
    },
  } as KVMessageDef
}
